import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzgxea65sk: FaireProductEntity = {
  token: "p_zzgxea65sk",
  type: "product",
  name: "lily of the valley notecards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/9dfce8ecd90693f29b032e0dbc02ce2627cfc520c593a56567d9a5cf0bf4fb21.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef4b7883940bf2b3862667cc293aabb8e0aac42c04561f790e54e61eed58020e.jpeg",
    "https://cdn.faire.com/fastly/b22d9d42258120b93647002daae7dec7ad47ed64f14251c19283fa05379a463c.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. The lily of the valley notecards are blank on the inside with a charming bouquet of lily of the valley watercolor illustration on the front. They bring a touch of cheer to your thank you notes, get well wishes, and more.\n\n• set of eight folded cards + envelopes\n• blank inside\n• 5.5" x 4.25"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:49.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
